<template>
  <div class="container activity-container">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/activity/list' }">拼团管理</el-breadcrumb-item>
        <el-breadcrumb-item>拼团创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left"></div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">拼团创建</h3>
      <div class="content">
        <el-form class="dataForm"
                 :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="110px">
          <el-form-item label="拼团名称"
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="请输入拼团标题"></el-input>
          </el-form-item>
          <el-form-item label="拼团简介"
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="请输入拼团简介，可用于描述使用规则"></el-input>
          </el-form-item>
          <el-form-item label="拼团商品"
                        prop="product_id">
            <el-button type="text"
                       @click="goodsChooseDialog = true"
                       v-if="!product">选择商品</el-button>
            <el-table v-if="product"
                      :data="product ? [product] : []"
                      size="mini"
                      style="width: 100%">
              <el-table-column label="商品">
                <template slot-scope="scope">
                  <div class="product-info">
                    <img :src="scope.row.picture_url" />
                    <div class="text-wrap">
                      <p class="name">
                        {{ scope.row.name || scope.row.title }}
                      </p>
                      <p>¥{{ scope.row.price }}</p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="规格">
                <template slot-scope="scope">
                  <div class="prop-info">
                    <div v-for="(item, index) of scope.row.properties"
                         :key="index">
                      <p>
                        {{ item.name }}：{{
                          item.values.map((v) => v.name).join("、")
                        }}
                      </p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作"
                               width="80">
                <template slot-scope="scope">
                  <el-button class="remove-text-button"
                             size="mini"
                             type="text"
                             @click="handleGoodsRemove(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item v-if="product"
                        label="商品价格"
                        prop="prices">
            <Property v-if="skus.length"
                      :content="{ skus: skus, properties: properties }"
                      @save="savePrices" />
            <el-table v-else
                      :data="product ? [product] : []"
                      size="mini">
              <el-table-column label="原价（元）">
                <template slot-scope="scope">
                  <span>{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column label="拼团价（元）"
                               width="160">
                <template slot="header">
                  <p><span style="color: #f00">*</span> 拼团价（元）</p>
                </template>
                <template>
                  <div><input v-model="prices[0].price" /></div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="拼团时间"
                        prop="datetime">
            <el-date-picker class="datetime"
                            v-model="dataForm.datetime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 400px"
                            :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="拼团有效期"
                        prop="valid_period">
            <el-select v-model="dataForm.days"
                       placeholder="天"
                       style="width: 100px"
                       @change="handleValidPeriodChange">
              <el-option v-for="item in days"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
            <span class="space">日</span>
            <el-select v-model="dataForm.hour"
                       placeholder="时"
                       style="width: 100px"
                       @change="handleValidPeriodChange">
              <el-option v-for="item in hours"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
            <span class="space">时</span>
            <el-select v-model="dataForm.minute"
                       placeholder="分"
                       style="width: 100px"
                       @change="handleValidPeriodChange">
              <el-option v-for="item in minutes"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
            <span class="space">分</span>
          </el-form-item>
          <el-form-item label="参团人数"
                        prop="user_count">
            <el-input v-model="dataForm.user_count"
                      placeholder="请输入参团人数，纯数字"
                      style="width: 400px"></el-input>
          </el-form-item>
          <el-form-item label="排序值"
                        prop="sort">
            <el-input v-model="dataForm.sort"
                      placeholder="请输入排序值，纯数字"
                      style="width: 400px"></el-input>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="模拟成团"
                          prop="simulate_status">
              <el-switch v-model="dataForm.simulate_status"></el-switch>
            </el-form-item>
            <!--           <el-form-item label="凑团" prop="open_status">
              <el-switch v-model="dataForm.open_status"></el-switch>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
    </div>
    <GoodsTabsChoose :visible="goodsChooseDialog"
                     type="single"
                     @close="goodsChooseDialog = false"
                     @submit="saveGoods"
                     :chooseable="flase" />
  </div>
</template>

<script>
import GoodsTabsChoose from '@/components/dialog/product/GoodsTabsChoose'
import Property from './property'
import { activityCreate } from '@/api/operation'
import { productOne } from '@/api/product'
import _ from 'lodash'

export default {
  components: {
    GoodsTabsChoose,
    Property,
  },
  watch: {
    // 时间数据监听
    'dataForm.datetime': {
      handler(value) {
        if (value) {
          this.dataForm.start_time = this.$moment(value[0]).valueOf()
          this.dataForm.end_time = this.$moment(value[1]).valueOf()
        } else {
          this.dataForm.start_time = null
          this.dataForm.end_time = null
        }
      },
    },
    product(val) {
      if (val) {
        this.dataForm.product_id = val.id
      }
    },
  },
  data() {
    return {
      goodsChooseDialog: false,
      dataForm: {
        days: '00',
        hour: '14',
        minute: '00',
        valid_period: 14 * 60,
      },
      product: null,
      skus: [],
      properties: [],
      days: new Array(31)
        .fill(1)
        .map((v, i) => (i.toString().length == 1 ? `0${i}` : `${i}`)),
      hours: new Array(60)
        .fill(1)
        .map((v, i) => (i.toString().length == 1 ? `0${i}` : `${i}`)),
      minutes: new Array(60)
        .fill(1)
        .map((v, i) => (i.toString().length == 1 ? `0${i}` : `${i}`)),
      prices: [{}],
      rules: {
        name: [{ required: true, message: '请输入拼团名称', trigger: 'blur' }],
        description: [
          { required: true, message: '请输入拼团简介', trigger: 'blur' },
        ],
        product_id: [
          {
            required: true,
            message: '请选择商品',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.product) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        prices: [
          {
            required: true,
            message: '请设置商品价格',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.prices || !this.prices.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        valid_period: [
          {
            required: true,
            message: '请设置拼团有效期',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.dataForm.valid_period) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        datetime: [
          { required: true, message: '请设置用券时间', trigger: 'change' },
        ],
        user_count: [
          {
            required: true,
            message: '请输入参团人数，纯数字',
            trigger: 'blur',
          },
        ],
        sort: [
          { required: true, message: '请输入排序值，纯数字', trigger: 'blur' },
        ],
        status: [
          { required: false, message: '请设置上线状态', trigger: 'change' },
        ],
        simulate_status: [
          { required: false, message: '请设置模拟成团状态', trigger: 'change' },
        ],
        open_status: [
          { required: false, message: '请设置凑团状态', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    // 商品详情查询
    fetchProductInfo() {
      productOne({ id: this.product.id }).then((res) => {
        if (res) {
          this.product = res

          this.dataForm.product_id = res.id
          if (res.skus.length) {
            const skus = _.cloneDeep(res.skus)
            skus.forEach((item) => {
              item.activity_price = item.activity_price || item.price
            })
            this.skus = skus
            const properties = _.cloneDeep(res.properties)
            this.properties = properties
          } else {
            const priceOne = {
              product_id: res.id,
              market_price: res.price,
              price: res.price,
            }
            this.prices = [priceOne]
          }
        }
      })
    },
    handleValidPeriodChange() {
      let minutes = Number(this.dataForm.minute)
      minutes += Number(this.dataForm.hour) * 60
      minutes += Number(this.dataForm.days) * 1440

      this.dataForm.valid_period = minutes
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            user_count: Number(this.dataForm.user_count),
            simulate_status: this.dataForm.simulate_status ? 1 : 0,
            open_status: this.dataForm.open_status ? 1 : 0,
            prices: this.prices.map((v) => {
              return {
                product_id: v.product_id,
                sku_id: v.sku_id || null,
                price: v.price,
              }
            }),
          })

          activityCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()

              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    savePrices({ prices } = {}) {
      this.prices = prices
    },
    saveGoods(product) {
      if (product) {
        this.product = product
        // 商品详情查询
        this.fetchProductInfo()
      }
    },
    handleGoodsRemove() {
      this.product = null
      this.skus = []
      this.properties = []
    },
    handleClose() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="less">
.activity-container {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      width: 100%;

      .input-radio {
        display: flex;
        align-items: center;
        height: 32px;

        & + .input-radio {
          margin-top: 10px;
        }

        .text {
          width: 60px;
        }
      }
      .space {
        margin: 0 10px;
      }

      /deep/ .el-radio__label {
        display: flex;
        align-items: center;
      }
      .form-item-wrap {
        display: flex;

        /deep/ .el-input {
          width: 300px;
        }
      }
    }
  }
  .product-info {
    display: flex;

    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
    }
    .text-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      overflow: hidden;
      margin-left: 5px;
    }
    .name {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
  }
}
</style>
